import { useState, useCallback, memo } from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { useDispatch, useSelector } from 'react-redux';
import { setLocationAction } from '../redux/features/mapView';
import { AppStore } from '../redux/store';
import { MAP_STYLE } from '../constants/MapConstants';
import useUserCountry from '../hooks/useUserCountry';

const zoom = 15;
const containerStyle = {
  width: '100%',
  height: '400px'
};

const svCenter = {
  lat: 13.701402266923608,
  lng: -89.22444462777489,
};

const gtCenter = {
  lat: 14.602933,
  lng: -90.5107544,
}


const MapPicker = () => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyB0c1nq-isvWJWWam5CICmPt0oYgY1A_eg"
  })
  const dispatch = useDispatch()
  let center

  const { getCurrentCountry } = useUserCountry()
  const currentUserCountryCode = getCurrentCountry()?.code

  if (currentUserCountryCode?.toLowerCase() === "sv") {
    center = svCenter
  } else if (currentUserCountryCode?.toLowerCase() === "gt") {
    center = gtCenter
  }

  const [mapView, setMapView] = useState(null)
  const mapViewState = useSelector((store: AppStore) => store.mapView)
  if (mapViewState.location && mapViewState.location.lat && mapViewState.location.lng) {
    center = mapViewState.location
  }

  const onLoad = useCallback(function callback(map: any) {
    map.setZoom(zoom)
    setMapView(map)
  }, [])

  const onUnmount = useCallback(function callback(map: any) {
    setMapView(null)
  }, [])

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={13}
      onLoad={onLoad}
      onUnmount={onUnmount}
      options={{
        minZoom: 13,
        styles: MAP_STYLE
      }}
      onClick={e => {
        if (e && e.latLng) {
          dispatch(setLocationAction({
            location: {
              lat: e.latLng?.lat(),
              lng: e.latLng?.lng()
            }
          }))
        }
      }}

    >
      <Marker
        position={center}
      />
    </GoogleMap>
  ) : <></>
}

export default memo(MapPicker)
